import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import StatsWidgetNumber from '@rio-cloud/rio-uikit/StatsWidgetNumber';
import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';
import { StatsWidgetSpacer } from '@rio-cloud/rio-uikit';
import { ScoreApiResponse } from '../../shared/models/ScoreApiResponse';
import { RouteMap } from '../../routes/routeList';
import { useNavigate } from 'react-router';
import useRelationshipStore from '../../services/relationshipStore';
import style from './relationshipCards.module.css'


type RelationshipCardsProps = {
    data: ScoreApiResponse | null;
    loading: boolean;
};

const RelationshipCards = (props: RelationshipCardsProps) => {
    const { data, loading } = props;
    const { data: relationshipScore, loading: relationshipLoading, postScore: relationshipPostScore } = useRelationshipStore();
    const behaviorRoute = `/${RouteMap.get('behavior')}`;
    const relationshipRoute = `/${RouteMap.get('relationship')}`;
    const financialHealthRoute = `${relationshipRoute}/${RouteMap.get('financialHealth')}`
    const connectionEngagementRoute = `${relationshipRoute}/${RouteMap.get('connectionEngagement')}`
    const operationalDisciplineRoute = `${relationshipRoute}/${RouteMap.get('operationalDiscipline')}`
    const navigate = useNavigate();

    return (
        <StatsWidget>
            <div className={location.pathname.includes(relationshipRoute) ? style['border-selction'] : style['border-inative']} >
                <StatsWidget.Header>Relacionamento</StatsWidget.Header>
                <StatsWidget.Body fullWidth>
                    {(() => {
                        if (loading) {
                            return (
                                <div>
                                    <div>
                                        <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                    </div>
                                    <div>
                                        <ContentLoader className='height-20' width={100} />
                                    </div>
                                </div>
                            )
                        } else {
                            const isClickable = location.pathname !== financialHealthRoute && location.pathname !== relationshipRoute && !location.pathname.includes(behaviorRoute);
                            return (
                                <StatsWidgetNumber clickable={isClickable} onClick={() => {
                                    if (isClickable) {
                                        navigate(financialHealthRoute);
                                    }
                                }} total={relationshipScore?.financialHealth.max} value={relationshipScore?.financialHealth.value} label='Saúde Financeira' />
                            )
                        }
                    })()}
                    <StatsWidgetSpacer />
                    {(() => {
                        if (loading) {
                            return (
                                <div>
                                    <div>
                                        <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                    </div>
                                    <div>
                                        <ContentLoader className='height-20' width={100} />
                                    </div>
                                </div>
                            )
                        } else {
                            const isClickable = location.pathname !== connectionEngagementRoute && location.pathname !== relationshipRoute && !location.pathname.includes(behaviorRoute);
                            return (
                                <StatsWidgetNumber clickable={isClickable} onClick={() => {
                                    if (isClickable) {
                                        navigate(connectionEngagementRoute);
                                    }
                                }} total={relationshipScore?.connectionEngagement.max} value={relationshipScore?.connectionEngagement.value} label='Vínculo e Engajamento' />
                            )
                        }
                    })()}
                    <StatsWidgetSpacer />
                    {(() => {
                        if (loading) {
                            return (
                                <div>
                                    <div>
                                        <ContentLoader className='height-20 margin-bottom-10' width={100} />
                                    </div>
                                    <div>
                                        <ContentLoader className='height-20' width={100} />
                                    </div>
                                </div>
                            )
                        } else {
                            const isClickable = location.pathname !== operationalDisciplineRoute && location.pathname !== relationshipRoute && !location.pathname.includes(behaviorRoute);
                            return (
                                <StatsWidgetNumber clickable={isClickable} onClick={() => {
                                    if (isClickable) {
                                        navigate(operationalDisciplineRoute);
                                    }
                                }} total={relationshipScore?.operationalDiscipline.max} value={relationshipScore?.operationalDiscipline.value} label='Disciplina Operacional' />
                            )
                        }
                    })()}
                </StatsWidget.Body>
            </div>
        </StatsWidget>
    );
};

export default RelationshipCards;